import { useParams } from 'react-router-dom'

export function EditPostPage() {
  const { id } = useParams<{ id: string }>()
  return (
    <div style={{ padding: 20, color: 'var(--text-body)', fontFamily: 'var(--font-sans)' }}>
      Edit post {id}
    </div>
  )
}
